import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import "./swiper.css";
import './Fetal.css';
import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import ShareOptions from './ShareOptions';
import EmailOverlay from '../common/EmailOverlay';
import CircularProgressBar from './CircularProgressBar';
import Slider from "./slider";
import Service from '../../service/Service';
// import * as actions from '../Actions';

const service = new Service();

class Fetal extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let articleData = [];
        let showMoreUrl = "";
        let lastUpdateFetus = '';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("serverSideData:::::::", serverSideData);
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['FetusInfo'] && serverSideData['data1']['msg'] == "1") {
                initialData = serverSideData['data1']['FetusInfo'];
                if (initialData.length > 0) {
                    lastUpdateFetus = initialData[0]['date'];
                }
            }
            if (serverSideData['data2'] && serverSideData['data2']['ArticleInfo'] && serverSideData['data2']['msg'] == "1") {
                articleData = serverSideData['data2']['ArticleInfo'];
                showMoreUrl = serverSideData['data2']['ShowmoreUrl'];
            }
        }
        this.state = {
            initialData: initialData,
            articleData: articleData,
            showMoreUrl: showMoreUrl,
            sessionStatus: "notrunning",
            windowWidth: 1024,
            isShowEmailTooltip: false,
            activeTab: "fetus",
            lastUpdateFetus: lastUpdateFetus,
            emailbody: "Hi,\nPlease find attached " + global.userAry['userName'] + "'s Fetus Movement Tracker history updated as on " + lastUpdateFetus + " for your kind reference.",
            percentage: 0,
            sessionTime: 0,
            timeString: "00:00",
            trackMsg: "Track Your Baby's Activity",
            kickCount: 0,
            fetusId: ""
        };
        this.timeout = 0;
        this.maxSessionTime = 120 * 60;
        this.isUpdatingKick = false;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "fetus/getFetusMovementTracker",
            body: JSON.stringify({
                "limit": "",
                "offset": "0"
            })
        };
        let obj2 = {
            url: global.api_url + "fetus/getArticleInformation",
            body: JSON.stringify({})
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
        this.domClick = this.domClick.bind(this);
        document.addEventListener("click", this.domClick);
        this.setState({ windowWidth: window.innerWidth });
        if (navigator.onLine) {
            let size = 10;
            if (this.qnaPageNo > 1) {
                size = 10 * this.qnaPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.fetusData();
            } else {
                localStorage.setItem('fetusDataLanding', JSON.stringify(this.state.initialData));
            }
            if (!this.state.articleData || (this.state.articleData && this.state.articleData.length < 1)) {
                service.showLoader();
                this.fetusArticleData();
            } else {
                localStorage.setItem('fetusArticleDataLanding', JSON.stringify(this.state.articleData));
                localStorage.setItem('fetusShowMoreUrlLanding', this.state.showMoreUrl);
            }
        } else {
            if (localStorage.getItem('fetusDataLanding')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('fetusDataLanding')) });
            }
            if (localStorage.getItem('fetusArticleDataLanding')) {
                this.setState({ articleData: JSON.parse(localStorage.getItem('fetusArticleDataLanding')) });
            }
            if (localStorage.getItem('fetusShowMoreUrlLanding')) {
                this.setState({ showMoreUrl: localStorage.getItem('fetusShowMoreUrlLanding') });
            }
            service.hideLoader();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
    }

    fetusData() {
        var postData = {
            "limit": "",
            "offset": "0"
        }
        var url = global.api_ci_url + "Fetus/onLoadfetusTrackerdata";
        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (json['msg'] == "1") {
                this.setState({ initialData: json['FetusInfo'] });
                localStorage.setItem('fetusDataLanding', JSON.stringify(json['FetusInfo']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    fetusArticleData() {
        var postData = {}
        var url = global.api_ci_url + "Fetus/getfetusArticleData";
        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (json['msg'] == "1") {
                this.setState({ articleData: json['ArticleInfo'], showMoreUrl: json['showMoreUrl'] });
                localStorage.setItem('fetusArticleDataLanding', JSON.stringify(json['ArticleInfo']));
                localStorage.setItem('fetusShowMoreUrlLanding', json['showMoreUrl']);
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    readMoreClick(event, dataId) {
        if (event.target.innerHTML == "Read More") {
            event.target.innerHTML = "Read Less";
            document.getElementById(dataId).style.height = 'auto';
        } else {
            event.target.innerHTML = "Read More";
            let maxHeight = 40;
            document.getElementById(dataId).style.height = maxHeight + 'px';
        }
    }

    loadReadMore() {
        let readmoreAry = document.getElementsByClassName('readmore_popup');
        for (let i = 0; i < readmoreAry.length; i++) {
            let maxHeight = 40;
            let dataId = readmoreAry[i].getAttribute('data-id');
            let divHeight = document.getElementById(dataId).offsetHeight;
            if (divHeight > maxHeight) {
                document.getElementById(dataId).style.height = maxHeight + 'px';
                readmoreAry[i].style.display = "inline-block";
            }
        }
    }

    changeFetusTab(name) {
        this.setState({ activeTab: name }, () => {
            if (name == "information") {
                this.loadReadMore();
            }
        })
    }

    shareOn(id) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
        if (window.innerWidth < 767) {
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'block';
            }
        }
    }

    shareUrl(shareoption, articleurl) {
        var shareurl;
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
        if (shareoption == "facebook") {
            shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
        } else if (shareoption == "twitter") {
            shareurl = 'https://twitter.com/share?url=';
        } else if (shareoption == "pintrest") {
            shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
        } else if (shareoption == "whatsapp") {
            shareurl = 'whatsapp://send?text=';
        }
        var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
        if (sharewindow.focus) {
            sharewindow.focus();
        }
        return false;
    }

    saveArticleLike(id, status) {
        if (global.ftk != '') {
            if (status == 1) {
                service.showLoader();
                var postData = {
                    "article_id": id,
                    "likeflg": status
                }
                var url = global.api_ci_url + "Fetus/saveArticleLikes";
                service.postServiceCall(url, postData).then((json) => {
                    console.log(json);
                    if (json['msg'] == "1") {
                        let articleData = this.state.articleData;
                        for (let i = 0; i < articleData.length; i++) {
                            if (articleData[i].id == id) {
                                articleData[i].islike = true;
                            }
                        }
                        this.setState({ articleData: articleData });
                    }
                    service.hideLoader();
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
            }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    deleteFeed(id) {
        if (this.state.isLogin == 0) {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
        document.getElementById("delete_record").setAttribute("data-id",id);
        document.getElementById("delete_record").setAttribute("data-id",id);
        document.getElementById("delete_record").style.display = "block";
    }

    cncldelfeedSum() {
        document.getElementById("delete_record").style.display = "none";
    }

    deleteKickHistory(id) {
        var id =  document.getElementById("delete_record").getAttribute("data-id");
        document.getElementById("delete_record").style.display = "none";
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "fetus_id": id,
                "status": "1"
            }
            var url = global.api_ci_url + "Fetus/deleteFetus";
            service.postServiceCall(url, postData).then((json) => {
                console.log(json);
                if (json['msg'] == "1") {
                    let initialData = this.state.initialData;
                    for (let i = 0; i < initialData.length; i++) {
                        if (initialData[i].id == id) {
                            initialData.splice(i, 1);
                        }
                    }
                    this.setState({ initialData: initialData });
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    domClick(event) {
        if (!event.target.classList.contains('share-click')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
        if (!event.target.classList.contains('open-email')) {
            this.setState({ isShowEmailTooltip: false });
        }
    }

    emailFetusInfo() {
        if (global.ftk != '') {
            console.log(this.state.emailbody);
            document.querySelector(".email-overlay").style.display = "block";
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    getTimeString(second) {
        var minutes = Math.floor(second / 60);
        second = second % 60;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        second = second < 10 ? '0' + second : second;
        var strTime = minutes + ':' + second;
        return strTime;
    }

    startKickSession() {
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "user_name": global.userAry['userName'],
                "kick_count": "0"
            }
            var url = global.api_ci_url + "Fetus/startFetusKickSession";
            service.postServiceCall(url, postData).then((json) => {
                console.log(json);
                if (json['msg'] == "1") {
                    document.getElementById('fetusTimeString').classList.remove('hideShow-msg');
                    this.setState({
                        sessionTime: 0,
                        percentage: 0,
                        timeString: "00:00",
                        kickCount: 0,
                        sessionStatus: "running",
                        trackMsg: "Kick Count is in Progress...",
                        fetusId: json['fetusid']
                    }, () => { this.setKickCount(); })
                    var _this = this;
                    _this.timeout = setInterval(function () {
                        let newTime = _this.state.sessionTime + 1;
                        if (newTime < _this.maxSessionTime) {
                            let percentage = newTime * 100 / _this.maxSessionTime;
                            _this.setState({
                                sessionTime: newTime,
                                percentage: percentage,
                                timeString: _this.getTimeString(newTime)
                            });
                        } else {
                            _this.stopKickSession();
                        }
                    }, 1000);
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    stopKickSession() {
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "fetus_id": this.state.fetusId,
                "kick_count": this.state.kickCount
            }
            var url = global.api_ci_url + "Fetus/stopFetusKickSession";
            service.postServiceCall(url, postData).then((json) => {
                console.log(json);
                if (json['msg'] == "1") {
                    this.fetusData();
                    clearInterval(this.timeout);
                    this.setState({
                        sessionStatus: "notrunning",
                        trackMsg: "Superb. " + this.state.kickCount + " Kicks in " + this.state.timeString + "  minutes for Today",
                        fetusId: ""
                    })
                    document.getElementById('fetusTimeString').classList.add('hideShow-msg');
                    var _this = this;
                    setTimeout(function () {
                        _this.setState({
                            sessionTime: 0,
                            percentage: 0,
                            timeString: "00:00",
                            trackMsg: "Track Your Baby's Activity",
                            kickCount: 0
                        }, () => { _this.setKickCount(); });
                        document.getElementById('fetusTimeString').classList.remove('hideShow-msg');
                    }, 15000);
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    updateKick() {
        if (!this.isUpdatingKick) {
            this.isUpdatingKick = true;
            console.log("updateKick");
            document.getElementById('nextSlide').click();
            this.setState({ kickCount: (this.state.kickCount + 1) }, () => { this.setKickCount(); });
            var _this = this;
            setTimeout(function () {
                _this.isUpdatingKick = false;
            }, 500);
        }
    }

    setKickCount() {
        let activeEle = document.getElementsByClassName('swiper-slide-active')[0];
        if(activeEle){
            activeEle.previousSibling.previousSibling.getElementsByClassName('kick-count')[0].innerHTML = (this.state.kickCount - 2) > 0 ? (this.state.kickCount - 2) : 0;
            activeEle.previousSibling.getElementsByClassName('kick-count')[0].innerHTML = (this.state.kickCount - 1) > 0 ? (this.state.kickCount - 1) : 0;
            activeEle.getElementsByClassName('kick-count')[0].innerHTML = this.state.kickCount;
            activeEle.nextSibling.getElementsByClassName('kick-count')[0].innerHTML = this.state.kickCount + 1;
            activeEle.nextSibling.nextSibling.getElementsByClassName('kick-count')[0].innerHTML = this.state.kickCount + 2;
    
        }
    }

    handleChangeEvent(event) {
        this.setState({
            percentage: event.target.value
        });
    }

    render() {
        return (
            <main className="fetal-main main-container">
                <Helmet
                    title="Fetal Movement Tracker to Count Baby Kicks - FirstCry Parenting"
                    meta={[
                        { "name": "description", "content": "Track & count your baby's daily kicks in womb, fetal movements, history and answers for all your queries related to fetal monitoring." },
                        { "name": "keywords", "content": "fetal movement tracker, baby kicks counter, fetal monitor" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Kick Counter</span>
                    </div>
                    <h1 className="B24_00">Baby Kick Counter</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="fetal-container">
                            <div className="tab-menu">
                                <ul className="tab-ul">
                                    <li className={this.state.activeTab == "fetus" ? "tab-li M18_f56996 tab-active" : "tab-li M18_42"} onClick={() => this.changeFetusTab("fetus")}>
                                        <div data-icon-font="&#xe02d;" className="icon"></div>
                                        <span className="tab-name" id="fetustab">Fetus</span>
                                    </li>
                                    <li className={this.state.activeTab == "history" ? "tab-li M18_f56996 tab-active" : "tab-li M18_42"} onClick={() => this.changeFetusTab("history")}>
                                        <div data-icon-font="." className="icon" ></div>
                                        <span className="tab-name" id="historytab">History</span>
                                    </li>
                                    <li className={this.state.activeTab == "information" ? "tab-li M18_f56996 tab-active" : "tab-li M18_42"} onClick={() => this.changeFetusTab("information")}>
                                        <div data-icon-font="&#xe030;" className="icon" ></div>
                                        <span className="tab-name" id="informationtab">Information</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="fetal-tab-content">
                                {this.state.activeTab == "fetus" &&
                                    <div className="fetal-tab-info" id="fetusTracker-tab1">
                                        <div className="fetusTracker-imgs">
                                            <div className="fetus-timer">
                                                <img className="fetus-timer-image" src={require('../images/fetus-timer-bg.png')} />
                                            </div>
                                            <div className="circles-container">
                                                <div id="fetusTimeString" className="circle-text M24_white">{this.state.timeString}</div>
                                                <CircularProgressBar
                                                    strokeWidth="9"
                                                    sqSize="150"
                                                    percentage={this.state.percentage} />
                                            </div>
                                            <div className="degrees-container">
                                                <span className="timer-degree zero-deg M14_9a2037">00</span>
                                                <span className="timer-degree thirty-deg M14_9a2037">30</span>
                                                <span className="timer-degree sixty-deg M14_9a2037">60</span>
                                                <span className="timer-degree ninty-deg M14_9a2037">90</span>
                                                <span className="timer-start-point"></span>
                                            </div>
                                            {this.state.trackMsg && this.state.trackMsg != "" &&
                                                <div className="fetus-track-msg">
                                                    <span className="M19_ef3b74">{this.state.trackMsg}</span>
                                                </div>
                                            }
                                            <div className="kick-slider">
                                                <Slider />
                                            </div>
                                            <div className="kickBtns">
                                                {this.state.sessionStatus == "notrunning" ?
                                                    <div id="startSession" className="askB_1 M14_white startsession" onClick={() => this.startKickSession()}>Start</div>
                                                    :
                                                    <div id="stopSession" className="askB_1 M14_white stopsession" onClick={() => this.stopKickSession()}>Stop</div>
                                                }
                                                {this.state.sessionStatus == "notrunning" ?
                                                    <div id="kickUpdate" className="askB_1 M14_white disabledKick">
                                                        <span className="icon kick-icon" data-icon-font="&#xe02c;"></span>
                                                        <span>Kick</span>
                                                    </div>
                                                    :
                                                    <div id="kickUpdate" className="askB_1 M14_white kickupdate" onClick={() => this.updateKick()}>
                                                        <span className="icon kick-icon" data-icon-font="&#xe02c;"></span>
                                                        <span>Kick</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {this.state.initialData && this.state.initialData.length > 0 &&
                                            <div className="kickHistory">
                                                <table className="kickHistoryTable" id="kickHistoryTable1">
                                                    <thead>
                                                        <tr>
                                                            <th className="M17_42 table_heading">DATE</th>
                                                            <th className="M17_42 table_heading">START</th>
                                                            <th className="M17_42 table_heading">DURATION</th>
                                                            <th className="M17_42 table_heading">KICKS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.initialData && this.state.initialData.map((fetus, index) =>
                                                            (index < 7 && <tr key={index} id="fetushistable" className={`fetushistable fetus${fetus.id}`}>
                                                                <td className="R15_42 kick_data">{fetus.date}</td>
                                                                <td className="R15_42 kick_data">{fetus.start_time}</td>
                                                                <td className="R15_42 kick_data">{fetus.duration}</td>
                                                                <td className="R15_42 kick_data">{fetus.kick_count}</td>
                                                            </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.activeTab == "history" &&
                                    <div className="fetal-tab-info" id="fetusTracker-tab2">
                                        {this.state.initialData && this.state.initialData.length > 0 &&
                                            (this.state.windowWidth < 768 ?
                                                <div className="emailFetus-mob left" id="email">
                                                    <span className="kick-history left">
                                                        <span className="left M15_42">Kick History</span>
                                                        <div data-icon-font="&#xe002;" className="icon right open-email" onClick={() => { this.setState({ isShowEmailTooltip: !this.state.isShowEmailTooltip }) }}></div>
                                                        {this.state.isShowEmailTooltip &&
                                                            <span className="email-tooltip" id="email" onClick={() => this.emailFetusInfo()}> EMAIL</span>
                                                        }
                                                    </span>
                                                </div>
                                                :
                                                <div className="emailFetus" id="email" onClick={() => this.emailFetusInfo()}>
                                                    <span>
                                                        <div data-icon-font="2" className="icon" id="email"></div>
                                                        <span className="M15_42">EMAIL</span>
                                                    </span>
                                                </div>
                                            )
                                        }
                                        <div className="kickHistory">
                                            <table className="kickHistoryTable" id="kickHistoryTable2">
                                                <thead>
                                                    <tr>
                                                        <th className="M17_42 table_heading">DATE</th>
                                                        <th className="M17_42 table_heading">START</th>
                                                        <th className="M17_42 table_heading">DURATION</th>
                                                        <th className="M17_42 table_heading">KICKS</th>
                                                    </tr>
                                                </thead>
                                                {this.state.initialData && this.state.initialData.length > 0 ?
                                                    <tbody>
                                                        {this.state.initialData && this.state.initialData.map((fetus, index) =>
                                                            <tr key={index} id="fetushistable" className={`fetushistable fetus${fetus.id}`}>
                                                                <td className="R15_42 kick_data">{fetus.date}</td>
                                                                <td className="R15_42 kick_data">{fetus.start_time}</td>
                                                                <td className="R15_42 kick_data">{fetus.duration}</td>
                                                                <td className="R15_42 kick_data">
                                                                    <span>{fetus.kick_count}</span>
                                                                    <span data-icon-font="&#xe013;" className="icon" id="delfetus" rel={fetus.id} onClick={(e) => this.deleteFeed(fetus.id)} ></span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    :
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="4">Sorry, no kick history available.</td>
                                                        </tr>
                                                    </tbody>
                                                }
                                            </table>
                                        </div>
                                        <input type="hidden" id="deleterecords" name="deleterecords" data-id="" value="" />
                                        <div className="share-overlay"></div>
                                        <div className="br_overlay delete_popup" id="delete_record" style={{ display: 'none' }}>
                                            <div className="delpopup">
                                                <p className="cmt_title M18_42">Delete Record?</p>
                                                <div className="cmt_btns">
                                                    <span className="cmt_cancel R14_61 delete-feed-popup" rel="0" onClick={(e) => { this.cncldelfeedSum() }}>CANCEL</span>
                                                    <span className="cmt_save R14_fc delete-feed-popup" rel="1" value="" onClick={(e) => this.deleteKickHistory()}>DELETE</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.state.activeTab == "information" &&
                                    <div className="fetal-tab-info" id="fetusTracker-tab3">
                                        {this.state.articleData && this.state.articleData.map((article, index) =>
                                            <div key={index} className="fetusArticle">
                                                <span className="article-img">
                                                    <img src={article.img_url} alt={article.title} title={article.title} />
                                                </span>
                                                <div className="fetusArticleContent">
                                                    <h2 className="fetusArticleTitle">
                                                        <span className="B20_42">{article.title}</span>
                                                    </h2>
                                                    <div className="R14_61 fetusArticlePara" id={`moretext_${article.id}`}>{article.discription}</div>
                                                    <div className="readmore_popup" data-id={`moretext_${article.id}`}>
                                                        <div className="readmorelink R14_link" onClick={(e) => this.readMoreClick(e, `moretext_${article.id}`)}>Read More</div>
                                                    </div>
                                                    <div className="fetusArticleLike">
                                                        <span className="social_activities R14_61">
                                                            <span className={article.islike ? "icon icon-active" : "icon"} data-icon-font="&#xe020;" onClick={() => this.saveArticleLike(article.id, article.islike ? 0 : 1)}></span>
                                                            <span className="R14_61">{service.intToString(article.like_count)} Likes</span>
                                                        </span>
                                                        <span className="social_activities">
                                                            <span className="R14_61 card-share" id={`share_${article.id}`}>
                                                                <div className="share-container share-click" onClick={() => this.shareOn(article.id)}>
                                                                    <div data-icon-font="&#xe027;" className="icon share-click"></div>
                                                                    <span className="R14_61 share-click">Share</span>
                                                                </div>
                                                                <ShareOptions url={article.sharelink} eleRef={this} />
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {this.state.showMoreUrl &&
                                            <div id="show-more-articles" className="askB_1">
                                                <a href={this.state.showMoreUrl} className="M14_white">SHOW MORE ARTICLES</a>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="share-overlay"></div>
                <EmailOverlay eleRef={this} />
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default Fetal;


// WEBPACK FOOTER //
// src/shared/tools/fetal-movement-tracker/Fetal.js